<template>
    <div class="page-container">
        <div class="widget-header-container">
          
            <div class="go_back" @click="$router.push({path:'/workTable'})"><i style="font-size: 24px;font-weight:bold;" class="el-icon-arrow-left"></i>
            </div>
            <div class="part-top">
                <input type="radio" :value="1" v-model="filter.taskType" id="taskwait"/>
                <label for="taskwait" @click="changeTab('1')">待开始任务</label>
                <input type="radio" :value="2" v-model="filter.taskType" id="taskGoing"/>
                <label for="taskGoing" @click="changeTab('2')" style="margin-left:30px">进行中任务</label>
                <input type="radio" :value="10" v-model="filter.taskType" id="taskQuality"/>
                <label for="taskQuality" @click="changeTab('10')">内部质控</label>
                <!--<input type="radio" :value="4" v-model="filter.taskType" id="taskFinish"/>-->
                <!--<label for="taskFinish">已完成任务</label>-->
                <!--<el-badge :is-dot="missedPatientList&& missedPatientList.length>0" class="item">-->
                <!--<input type="radio" :value="-1 " v-model="filter.taskType" id="unanswered"/>-->
                <!--<label for="unanswered">未接来电记录</label>-->
                <!--</el-badge>-->
                <!--<div >-->
                <!--<el-button @click="goNextPage">跳转到下一个页面</el-button>-->
                <!--</div>-->
            </div>

        </div>
        <div class="widget-content-container" v-if="filter.taskType == 1">
             <taskwait :taskSource="taskSource" :diseaseList="diseaseList"></taskwait>
        </div>
        <div class="widget-content-container" v-if="filter.taskType == 2">
            <div class="part-bottom">
                <div class="filter">
                    <el-form :inline="true" :model="filter">

                        <el-form-item label="任务来源:">
                            <el-select v-model="filter.taskSourceType" @change="searchHandle" filterable clearable placeholder="请选择任务来源"
                                       size="small">
                                <el-option v-for="item in taskSource" :label="item.label" :value="item.value"
                                           :key="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="任务ID:">
                            <el-input size="small" placeholder="请输入任务ID" @change="searchHandle" v-model="filter.taskId" clearable
                                      maxlength="50"></el-input>
                        </el-form-item>
                        <el-form-item label="随访疾病:">
                            <el-select v-model="filter.diseaseId" @change="searchHandle" filterable clearable placeholder="请选择随访疾病"
                                       size="small">
                                <el-option v-for="item in diseaseList" :label="item.diseaseName" :value="item.id"
                                           :key="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="任务名称:">
                            <el-input placeholder="请输入随访任务名称" size="small" v-model="filter.title" clearable @change="searchHandle"
                                      maxlength="50"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="searchHandle" size="small">查询</el-button>
                            <el-button type="primary" @click="resetHandle" size="small">清空</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
              <div class="pagination">
                    <el-pagination
                            background
                            layout="total, prev, pager, next, jumper"
                            :page-count="totalPage"
                            :current-page="currentPage"
                            @current-change="current_change"
                            :hide-on-single-page="true"
                    ></el-pagination>
                </div>
            <div>
                <!-- <div v-for="task in tableData" class="box">
                    <taskContainer :taskInfo="task" v-loading="tableLoading"></taskContainer>
                </div> -->
                <taskContainer  :tableData="tableData" v-loading="tableLoading"></taskContainer>

            </div>

        </div>
        <div class="widget-content-container" v-if="filter.taskType == 10">
            <div class="part-header">
                <span>今日抽查/需抽查: ({{qualityDetail.todayCheckRatio}})</span>
                <span>当月抽查/需抽查: ({{qualityDetail.thisMonthCheckRatio}})</span>
                <span>合格: {{qualityDetail.qualified}}</span>
                <span>不合格: {{qualityDetail.notQualified}}</span>
            </div>
            <taskSport :tableData="qualityDetail.seatTaskList"></taskSport>
        </div>

    </div>
</template>

<script type="text/ecmascript-6">
import {
  RestFeedbackOutControllerMainOfController,
  RestFeedbackOutControllerGetIsAllRead,
  RestNewFollowupCallCenterServiceGetQueryQFollowUpTaskList,
  RestIncomingCallControllerGetMissedCallResultList, // 获取未接来电记录
  RestNewFollowupCallCenterServiceGetDiseaseClassificationList, //获取疾病列表
  RestNewFollowupQuestionListServiceGetFollowupTaskQuestionnaireNewId,
} from "@src/assets/js/api.js";
import errorHandleMixin from "@mixins/errorHandleMixin";
import { mapGetters, mapMutations, mapState } from "vuex";
import qsDetailDB from "@src/assets/qsList/indexDB.js";
import taskContainer from "./taskTableList";
import taskSport from "./sportCheck";
import taskwait from "./waitTaskList";
export default {
  name: "TaskFilterListTable",
  data() {
    return {
      qualityDetail: {},
      taskName: "", // title
      filter: {
        taskSourceType: "",
        diseaseId: "",
        taskType: 2, // 默认 进行中 的任务
        title: "",
        taskId: ""
      },
      taskSource: [
        { label: "医院", value: 1 },
        { label: "公司", value: 2 },
        { label: "荟医", value: 3 },
        {
          label: "其他",
          value: 4,
        },
      ],
      diseaseList: [],
      // pagination ========
      totalPage: 1,
      currentPage: 1,
      // table =====
      tableLoading: false,
      tableData: [{}],
      missedPatientList: [],
    };
  },
  computed: {
    ...mapGetters(["userid", "questionId"]),
  },
  filters: {
    formatTags: function(value, power) {
      var taskTags = [
        { label: "急", value: 1, power: 1, showPower: false },
        {
          label: "V",
          value: 2,
          power: 1,
          showPower: false,
        },
        { label: "重", value: 3, power: 1, showPower: false },
        {
          label: "密",
          value: 4,
          power: 1,
          showPower: false,
        },
        { label: "合", value: 5, power: 1, showPower: false },
        {
          label: "单",
          value: 6,
          power: 1,
          showPower: false,
        },
        { label: "难", value: 7, power: 1, showPower: false },
        {
          label: "免",
          value: 8,
          power: 1,
          showPower: false,
        },
      ];
      var str = ["+", "++", "+++"];
      var result = [];
      power = String(power);
      if (value) {
        value = String(value);
        for (var i = 0; i < value.length; i++) {
          var item = value[i];
          var p = power[i] > 3 ? 3 : power[i];
          var tag = taskTags.find((v, i) => {
            return v.value == item;
          });
          var rs = tag.label + str[p - 1];
          if (result.length == 0) {
            result.push(rs);
          } else {
            if (!rs.length < result[0].length) {
              result.unshift(rs);
            } else {
              result.push(rs);
            }
          }
        }
        return result.join(";");
      } else {
        return "暂无";
      }
    },
    formatfollowUpWay: function(value) {
      var text = "";
      switch (value) {
        case 11:
          text = "线上+电话";
          break;
        case 12:
          text = "电话";
          break;
        case 21:
          text = "线上";
          break;
        default:
          text = "未知";
          break;
      }
      return text;
    },
    formatSourceType: function(value) {
      var text = "";
      switch (value) {
        case 1:
          text = "医院";
          break;
        case 2:
          text = "公司";
          break;
        case 3:
          text = "荟医";
          break;
        default:
          text = "其他";
          break;
      }
      return text;
    },
  },
  components: { taskContainer, taskSport,taskwait },
  watch: {
    "filter.taskType"(nval, oval) {
      console.log('nval   ', nval)
      this.filter.taskType = nval
      this.resetHandle();
      this.getMissedCallsList();
      this.getTableList()
    },
  },
  created() {
    
      if(this.$route.query.fixed==10){
        this.filter.taskType =10
      }
  },
  mounted() {
    window.pubsub &&
      window.pubsub.off("refreshHomePage").on("refreshHomePage", () => {
        this.onLoad();
      });
    // qsDetailDB.openDatabase();
    this.onLoad();
  },
  mixins: [errorHandleMixin],
  methods: {
    ...mapMutations(["setTaskCenterId", "setTaskType", "setQuestion"]),
    onLoad() {
      // qsDetailDB.openDatabase();
      this.getTableList();
      // this.getMissedCallsList()
      this.getDiseaseList();
      this.mainOfControllerAsync(sessionStorage.getItem("userid")).then(
        (res) => {
          this.qualityDetail = res.retValue;
          console.log(res);
        }
      );
    },
    changeTab(num){
      console.log('numj', num)
      this.filter.taskType=num
    },
    // =========================  table handle =========================
    startWorkHandle(event, row) {
      this.setTaskCenterId(row.id);
      this.setTaskType(row.callType);
      var id = row.copyQuestionnaireId.indexOf(",")
        ? row.copyQuestionnaireId.split(",")[0]
        : row.copyQuestionnaireId;
      this.getFollowupTaskQuestionnaireNewId(row.id).then((res) => {
        if (res.status == 0) {
          this.setQuestion(res.retValue);
        }
      });
      this.$router.push({
        path: "/taskDetail",
        query: {
          diseaseId: row.diseaseId,
        },
      });
    },

    // ===========================过滤状态===============================
    searchHandle() {
      this.currentPage = 1
      this.getTableList();
    },
    resetHandle() {
      this.filter.taskSourceType = "";
      this.filter.diseaseId = "";
      this.filter.title = "";
      this.filter.taskId = "";
      this.searchHandle()
    },
    // =============================== pagination   =======================================
    // 分页 交互
    current_change(currentPage) {
      console.log("page changes", arguments, currentPage);
      this.currentPage = currentPage;
      this.getTableList({
        pageSize: currentPage,
      });
    },
    //=============================质控===============================
    goToPage(page, taskId) {
      localStorage.setItem("taskId", taskId);
      console.log(1111);
      this.$router.push({
        path: `/${page}`,
      });
    },
    // ============================事件处理 ===========================

    goBack() {
      return this.$router.go(-1);
    },
    goNextPage() {
      this.$router.push({
        path: "/tasks",
      });
    },
    //
    getQuery(param = {}) {
      let obj = {
        pageSize: 1,
      };
      return obj;
    },
    async getDiseaseList() {
      let vm = this;
      let info = new RestNewFollowupCallCenterServiceGetDiseaseClassificationList();
      await info.send();
      if (info.result.status == 0) {
        vm.diseaseList = info.result.retValue;
      } else {
        vm.diseaseList = [];
      }
    },
    getTableList() {
      this.tableLoading = true;
      this.getTableListAsync()
        .then((result) => {
          this.tableLoading = false;
          if (_.isArray(result)) {
            this.tableData.splice(0, this.tableData.length);
            _.each(result, (item) => {
              this.tableData.push(item);
            });
          }
        })
        .catch((err) => {
          this.tableLoading = false;
        });
    },
    async getFollowupTaskQuestionnaireNewId(id) {
      let request = new RestNewFollowupQuestionListServiceGetFollowupTaskQuestionnaireNewId();
      request.p_followupTaskId = id;
      await request.send();
      return request.result;
    },
    async getTableListAsync() {
      let data = new RestNewFollowupCallCenterServiceGetQueryQFollowUpTaskList();
      data.p_userId = this.userid;
      data.p_status = this.filter.taskType;
      data.p_taskId = this.filter.taskId;
      data.p_diseaseId = this.filter.diseaseId || null;
      data.p_taskSourceType = this.filter.taskSourceType || null;
      data.p_pageIndex = this.currentPage;
      data.p_pageSize = 10;
      if (this.filter.title && this.filter.title.trim().length > 0) {
        data.p_title = this.filter.title;
      }
      await data.send();
      this.totalPage = data.result.totalPage;
      this.currentPage = data.result.page;
      if (data.result.status == 0) {
        return data.result.retValue;
      } else {
        this.errorHandle(data.result.retValue);
      }
    },
    async getHospitalListAsync() {
      let data = new Array();
      await data.send();
      return data.result;
    },
    async getDepartmentListAsync() {
      let data = new Array();
      await data.send();
      return data.result;
    },
    /**
     * 获取未接来电记录
     * @returns {Promise<void>}
     */
    async getMissedCallsList() {
      let vm = this;
      let info = new RestIncomingCallControllerGetMissedCallResultList();
      info.p_userId = vm.userid;
      info.p_pageIndex = 1;
      info.p_pageSize = 30;
      await info.send();
      if (info.result.status == 0) {
        var pat = /(\d{3})\d*(\d{4})/;
        info.result.retValue.forEach((item) => {
          item.numberStr = item.incomingTelegramNumber.replace(pat, "$1****$2");
        });
        vm.missedPatientList = info.result.retValue;
      } else {
        vm.missedPatientList = [];
        // this.$message({
        //     type: "waring",
        //     message: '获取未接来电记录失败'
        // });
      }
    },
    async callBackPatient(event, rowData) {
      window.workbench.call(
        rowData.incomingTelegramNumber,
        "auto",
        null,
        false
      );
      window.pubsub.emit("seat-call-back-patient", {
        caller: rowData.incomingTelegramNumber,
      });
    },
    async mainOfControllerAsync(seatId) {
      let request = new RestFeedbackOutControllerMainOfController();
      request.p_seatId = seatId;
      request.p_fig = localStorage.getItem('fp')
      request.p_ip = localStorage.getItem('ip')
      await request.send();
      return request.result;
    },
  },
};
</script>

<style lang="scss">
$taskNameColor: red;
.danger {
  // background-color: yellow;
}
.task-container {
  width: 96%;
  margin: 0 auto;
}
.page-container {
  .box {
    margin-top: 20px;

    &:first-child {
      margin-top: 0;
    }
  }

  .pagination {
    margin-bottom: 10px;
    text-align: right;
  }

  .widget-header-container {
    .part-top {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 60px;
      background: rgba(255, 255, 255, 1);

    }
  }

  .widget-content-container {
    background: rgba(250, 250, 250, 0.6);

    .part-bottom {
      display: flex;
      justify-content: space-between;
      align-items: center;
      box-shadow: 0px -1px 0px 0px rgba(0, 0, 0, 0.08);
      padding-left: 50px;
      padding-right: 50px;
      height: 64px;

      .filter {
        .el-form {
          display: flex;
          justify-content: flex-start;
          align-items: center;

          .el-form-item {
            margin-bottom: 0px;
            margin-right: 40px;
          }
        }
      }
    }

    .table-container {
      margin-left: 30px;
      margin-right: 30px;
      padding-top: 1px;
      box-shadow: 0px 0px 4px 1px rgba(0, 0, 0, 0.1);
      border-radius: 10px;
      background: rgba(255, 255, 255, 1);
      padding: 0px;

      .table-header-title {
        width: 100%;
        height: 60px;
        border: 1px solid #ebeef5;
        border-bottom: none;
        box-sizing: border-box;
        text-align: left;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .header-title-left {
          // 患者信息列表
          & > span:nth-of-type(1) {
            font-size: 18px;
            padding-top: 10px;
            padding-left: 20px;
            border-left: 2px solid black;
            margin-left: 20px;
          }

          // 刷新
          & > span:nth-of-type(2) {
            font-size: 20px;
            margin-right: 40px;
          }
        }

        .record-wrapper {
          display: flex;
          justify-content: flex-end;
          align-items: center;

          .detail {
            position: relative;

            .hideList {
              display: none;
            }

            .status-list {
              position: absolute;
              top: 90px;
              left: 80px;

              li {
                width: 180px;
                display: flex;
                justify-content: space-between;

                & > span:nth-of-type(2) {
                  display: inline-block;
                  width: 140px;
                  text-align: left;
                }
              }
            }
          }
        }
      }
    }

    .part-header {
      display: flex;
      padding: 20px 0;
      margin-left: 60px;

      span {
        font-size: 20px;
        font-weight: 700;
        margin: 0 15px;
      }
    }

    .part-container {
      display: flex;
      flex-wrap: wrap;
      align-items: center;

      .part-item {
        width: 40%;
        margin-left: 70px;
        margin-bottom: 50px;
        padding: 10px;
        background-color: #fff;
        border-radius: 8px;
        box-shadow: 1px 1px 1px 1px #ccc;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .part-item-left {
          flex: 0.5;
          display: flex;
          justify-content: space-around;
          align-items: center;
          border-right: 1px solid #ccc;

          .left-icon {
            background-color: #1ec738;
            width: 72px;
            height: 72px;
            font-weight: 700;
            color: #fff;
            line-height: 72px;
            border-radius: 8px;
          }

          .left-content {
            width: 70%;
            margin-left: 10px;
            text-align: left;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: space-between;
            height: 68px;

            .left-content-top {
              font-weight: 700;
              font-size: 16px;
              letter-spacing: 2px;
            }
          }
        }

        .part-item-right {
          display: flex;
          align-items: center;
          justify-content: space-around;
          flex: 0.5;

          .right-item {
            display: flex;
            flex-direction: column;
            height: 68px;
            justify-content: space-around;
          }
        }
      }
    }
  }
}
</style>
<style lang="scss">
.table-title {
  .el-form-item__label {
    font-size: 14px;
    font-weight: 600;
    color: #000;
  }
}

.filter-task-table {
  .el-table__header-wrapper {
    table {
      thead {
        font-weight: 600;
        font-size: 16px;
        color: rgba(0, 0, 0, 0.9);
      }
    }
  }
}

.page-container {
  .widget-header-container {
    position: relative;
    .part-top {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 60px;
      background: rgba(255, 255, 255, 1);

      input {
        display: none;
      }

      label {
        padding: 10px 40px;
        border: 1px solid #e0e0e0;
        color: #a0a0a0;
        border-radius: 4px;
        cursor: pointer;

        &:nth-last-of-type(1) {
          margin-left: 30px;
        }
      }

      input:checked + label {
        background-color: #248cfa;
        color: #fff;
        border: 1px solid #248cfa;
      }
    }
    .go_back {
        height: 50px;
        width: 40px;
        line-height: 50px;
        text-align: center;
        position: absolute;
    }
    .go_back:hover {
        background: rgb(226, 226, 226);
        cursor: pointer;
    }
  }

  .el-badge__content.is-fixed.is-dot {
    top: -8px;
  }
}
</style>
